import { createStyles, makeStyles, styled } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
const { DARK_CONTAINER_FIELDS_ON_CARD, DARK_FIELDS_ON_CARD_TEXTBOX_BACKGROUND, PLAIN_TEXT } = COLORS;

export const useStyles = makeStyles(() =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',

      '& .MuiOutlinedInput-root': {
        height: '50px!important',
        fontSize: 14,
        background: DARK_FIELDS_ON_CARD_TEXTBOX_BACKGROUND,
      },

      '& .MuiFormLabel-root': {
        display: 'flex',
        justifyContent: 'space-between',
        fontSize: '13px',
        letterSpacing: '1px',
        alignItems: 'center',
        color: PLAIN_TEXT,

        '& .MuiBox-root': {
          padding: '2px 4px 1px 5px',
          border: '1px solid',
          borderRadius: '100%',
          fontSize: '12px',
        },
      },

      '& .MuiSelect-iconOutlined': {
        right: '0',
        top: '22px',
      },

      '& .MuiSelect-iconOpen': {
        top: '2px',
        right: '13px',
      },
    },
    header: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      marginBottom: 30,
      textAlign: 'center',

      alignSelf: 'center',
    },
    form: {
      display: 'flex',
      flexDirection: 'column',
      gap: 15,
      alignItems: 'center',
      margin: 10,
      marginBottom: 20,
      padding: 15,
    },
    boxContainer: {
      background: DARK_CONTAINER_FIELDS_ON_CARD,
      height: 329,
      borderRadius: 5,
      width: 224,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',

      '&:hover': {
        opacity: 0.8,
      },
    },
    icon: {
      width: 38,
      height: 38,
      marginBottom: 20,
    },
    buttonCls: {
      height: '60px !important',
      borderRadius: 8,
      textTransform: 'unset',
      textDecoration: 'none!important',
      maxWidth: 335,
      fontSize: 16,
      alignSelf: 'center',
    },
  }),
);

export const MemberImage = styled('img')(({ theme }) => ({
  height: 329,
  minWidth: 224,
  borderRadius: 5,
}));
